import { createContext, useState } from "react";

const BetContext = createContext();

export const BetProvider = ({ children }) => {
  const [selectedBet, setSelectedBet] = useState(null);

  return (
    <BetContext.Provider value={{ selectedBet, setSelectedBet }}>
      {children}
    </BetContext.Provider>
  );
};

export { BetContext };
